import { SuspenseQueryErrorHandling } from '@shared/components/SuspenseQueryErrorHandling.tsx';
import useGetUnion from '@my-pages/features/membership/hooks/useGetUnion.ts';

const SectionCardContent = () => {
    const union = useGetUnion();
    return (
        <div className='ft-table ft-responsive-sm table-mark-empty mb-0 font-size-sm'>
            <div className='ft-tr'>
                <div className='ft-th'>Avdelning</div>
                <div className='ft-td'>{union.orgName}</div>
            </div>
            <div className='ft-tr'>
                <div className='ft-th'>Sektion</div>
                <div className='ft-td'>{union.name}</div>
            </div>
        </div>
    );
};

const SectionCard = () => {
    return (
        <div className='card card-body mb-4'>
            <h4>Avdelning och sektion</h4>
            <SuspenseQueryErrorHandling errorMessage='Kunde inte hämta uppgifter rörande avdelning och sektion.'>
                <SectionCardContent />
            </SuspenseQueryErrorHandling>
        </div>
    );
};

export default SectionCard;
